import styled from "styled-components";
import ThemeColors from "../../themes/colors";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background-color: ${ThemeColors.Bg2500};
  width: 100%;
  height: 100%;
`;

export const EnterpriseList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 1rem;
  padding: 0 2rem;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const EmptyImg = styled.img`
  height: 10rem;
`;